// extracted by mini-css-extract-plugin
export default {"wrapper":"mUQEE_","wrapper--s":"EltjaO","input-wrapper":"ox7XA0","submit-wrapper":"gOLjwd","personal-data-link":"VZCf14"};